import {v4 as uuidv4} from 'uuid';
import img1 from '../../assets/img/home3/quotes.png';

const TestimonialTwoData = [
    {
        id: uuidv4(),
        img: img1,
        name: 'CEO, Snyder Digital',
        designation: 'Contructor',
        speech: 'Busicon has been around for more than adecade. It’s a trusted social media tool for businesses of all shapes and sizes.',
    },

    {
        id: uuidv4(),
        img: img1,
        name: 'Rubel Ahned',
        designation: 'Founder, RRDevs',
        speech: 'Busicon has been around for more than adecade. It’s a trusted social media tool for businesses of all shapes and sizes.',
    },

    {
        id: uuidv4(),
        img: img1,
        name: 'Salman Ahned',
        designation: 'CEO, ModinaThemes',
        speech: 'Busicon has been around for more than adecade. It’s a trusted social media tool for businesses of all shapes and sizes.',
    },
    
]

export default TestimonialTwoData;